import { render, staticRenderFns } from "./MonthYearProperties.vue?vue&type=template&id=28485888&scoped=true"
import script from "./MonthYearProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonthYearProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MonthYearProperties.vue?vue&type=style&index=0&id=28485888&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28485888",
  null
  
)

export default component.exports